import { render, staticRenderFns } from "./RewardBoxBanner.vue?vue&type=template&id=31d2991c"
import script from "./RewardBoxBanner.vue?vue&type=script&lang=js"
export * from "./RewardBoxBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports